import { useState, useEffect, useCallback } from 'react';
import identityService from '../services/identityService';

/**
 * Hook to fetch and manage identity statistics
 * @returns {Object} Stats state and methods
 */
export const useStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStats = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await identityService.getStats();
      // console.log("fetch stats",response.data)
      if (response?.success) {
        setStats(response?.data);
      } else {
        setError(response?.error?.message || 'Failed to fetch statistics');
      }
    } catch (err) {
      setError(err?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return {
    stats,
    loading,
    error,
    refetch: fetchStats
  };
};

export default useStats;